var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list_board" }, [
    _c("table", { staticClass: "tbl_board_g" }, [
      _c("caption", [_vm._v("게시글 목록")]),
      _vm._v(" "),
      _c("thead", [
        _c("tr", [
          !_vm.isSearch
            ? _c("th", { staticClass: "td_board", attrs: { scope: "col" } }, [
                _c("span", { staticClass: "screen_out" }, [
                  _vm._v("리스트 번호"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("th", { staticClass: "td_title t_c", attrs: { scope: "col" } }, [
            _vm._v("제목"),
          ]),
          _vm._v(" "),
          _vm.showsAuthor
            ? _c("th", { staticClass: "td_writer", attrs: { scope: "col" } }, [
                _vm._v("글쓴이"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("th", { staticClass: "td_date", attrs: { scope: "col" } }, [
            _vm._v("작성일"),
          ]),
          _vm._v(" "),
          !_vm.isSearch
            ? _c(
                "th",
                { staticClass: "td_recommend", attrs: { scope: "col" } },
                [_vm._v("추천")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("th", { staticClass: "td_look", attrs: { scope: "col" } }, [
            _vm._v("조회"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        { attrs: { id: "more-article-list" } },
        [
          _vm._l(_vm.articles, function (article) {
            return [
              _vm.isRestricted(article)
                ? _c(
                    "restricted-common-article-item",
                    _vm._b({}, "restricted-common-article-item", article, false)
                  )
                : _c(
                    "common-article-item",
                    _vm._b({}, "common-article-item", article, false)
                  ),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }